import { useStores } from '@/stores';
import { ICompatibility } from '@/stores/compatibility/compatibility.interface';

export const useCurrentCompatibility = (): ICompatibility => {
  const { compatibilityStore } = useStores();
  return compatibilityStore.compatibility;
};
